<template>
  <div>
    <div
      v-for="(childMenu) in menu.children"
      :key="childMenu.name"
    >
      <div v-if="childMenu.children && childMenu.children.length" class="level-two-title">{{ childMenu.meta.title }}</div>
      <el-row v-if="childMenu.children && childMenu.children.length">
        <sidebar-item :base-path="resolvePath(childMenu.path)" :menu="childMenu" />
      </el-row>
      <el-row v-else-if="!childMenu.hide">
        <app-link class="link-item" :class="isActive(childMenu)?'active':''" :to="resolvePath(childMenu.path)" :params="childMenu.meta.params">{{ childMenu.meta.title }}</app-link>
      </el-row>
    </div>
  </div>
</template>

<script>
import path from 'path'
import AppLink from './Link.vue'

export default {
  name: 'SidebarItem',
  components: {
    AppLink
  },
  props: {
    menu: {
      type: Object,
      default() {
        return {}
      }
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    resolvePath(routePath) {
      if (this.$utils.isExternal(routePath)) {
        return routePath
      }
      if (this.$utils.isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    isActive(menu) {
      return this.$route.name === menu.name
    }
  }
}
</script>

<style lang="scss" scoped>
.level-two-title {
  font-size: 16px;
  font-weight: 600;
  color: #d2d2d6;
  margin: 19px 0 11px 32px;
}
.link-item {
  width: 164px;
  height: 32px;
  margin: 2px 0 0 16px;
  border-radius: 4px;
  display: inline-block;
  padding-left: 16px;
  font-size: 13px;
  font-weight: 400;
  color: #333;
  transition: background-color .1s ease-out;
  cursor: pointer;
  &:hover {
    color: #FFFFFF;
    font-weight: 500;
    background-color: $main-color;
    box-shadow: 0px 3px 3px 1px rgba(130, 97, 247, 0.17);
  }
  &.active{
    color: #FFFFFF;
    font-weight: 500;
    background-color: $main-color;
    box-shadow: 0px 3px 3px 1px rgba(130, 97, 247, 0.17);
  }
}
</style>
